import React, { useEffect, useState } from 'react'
interface PopUpProps {
    isVisible: boolean
    onClose: () => void
    title?: string
    workSpaceData?: GetRoleDashBoardsToAdd
    onSave?: (dashBoardId: number) => Promise<void>
}
interface RoleDashBoardsToAdd {
    CreatedByUserId: number
    CreatedOn: Date
    DashBoardGuid: string
    DashBoardId: number
    Description: string
    LastUpdatedByUserId: number
    LastUpdatedOn: Date
    Name: string
    SharedRolesCount: number
    SharedUsersCount: number
    numberofVU: number
    profilePic: string
    rgborname_color: string
}

interface GetRoleDashBoardsToAdd {
    roleId: number
    dashBoards: RoleDashBoardsToAdd[]  //  Dashboards available to add 
}

const AddWorkspaceToRole: React.FC<PopUpProps> = ({
    isVisible,
    onClose,
    title,
    workSpaceData,
    onSave,
}) => {
    const [selectedWorkspaceId, setSelectedWorkspaceId] = useState<number | null>(null) // Store the ID of the selected workspace
    const [searchTerm, setSearchTerm] = useState<string>('') // Search term state
    const [filteredWorkspaces, setFilteredWorkspaces] = useState<RoleDashBoardsToAdd[]>([]) // Filtered workspaces
    const [isProcessing, setIsProcessing] = useState(false);
        
    useEffect(() => {
        if (workSpaceData) {
            const filtered = workSpaceData.dashBoards.filter((workspace) =>
                workspace.Name.toLowerCase().includes(searchTerm.toLowerCase())
            )
            setFilteredWorkspaces(filtered)
        }
    }, [searchTerm, workSpaceData])

    useEffect(() => {
        setSelectedWorkspaceId(null);
    }, [workSpaceData]);

    if (!isVisible) return null

    const handleWorkspaceSelection = (workspaceId: number) => {
        setSelectedWorkspaceId(workspaceId)
    }

    return (
        <>
            <div className="ui-widget-overlay ui-front" style={{ zIndex: 100 }}></div>
            <div
                tabIndex={-1}
                role="dialog"
                className="ui-dialog ui-corner-all ui-widget ui-widget-content ui-front ui-dialog-buttons"
                aria-describedby="role_dashboard_to_add_wrapper"
                aria-labelledby="ui-id-1"
                style={{
                    height: 'auto',
                    width: '600px',
                    top: '50%',
                    left: '50%',
                    position: 'fixed',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 101,
                }}
            >
                <div className="ui-dialog-titlebar ui-corner-all ui-widget-header ui-helper-clearfix">
                    <span id="ui-id-1" className="ui-dialog-title">
                        {title}
                    </span>
                    <button
                        type="button"
                        className="ui-button ui-corner-all ui-widget ui-button-icon-only ui-dialog-titlebar-close"
                        title="Close"
                        onClick={onClose}
                    >
                        <span className="ui-button-icon ui-icon ui-icon-closethick"></span>
                        <span className="ui-button-icon-space"> </span>Close
                    </button>
                </div>

                <div
                    id="role_dashboard_to_add_wrapper"
                    className="ui-dialog-content ui-widget-content"
                    style={{
                        display: 'block',
                        width: 'auto',
                        minHeight: '43.6px',
                        maxHeight: 'none',
                        height: 'auto',
                    }}
                >
                    <div className="padding-bottom-medium">
                        Select a workspace to add to this role.
                    </div>
                    <div id="role_dashboard_quick_search" className="quick-search">
                        <div className="search-text-wrapper">
                            <span className="search-image"></span>
                            <input
                                type="text"
                                id="text_role_dashboard_search"
                                value={searchTerm}
                                className="input-text"
                                placeholder="search..."
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                    </div>
                    <ol id="selectable_role_dashboards_to_add" className="dashboard-list">

                        {filteredWorkspaces.length > 0 ? (
                            filteredWorkspaces.map((workspace) => (
                                <li
                                    key={workspace.DashBoardId}
                                    id={`dashboard_${workspace.DashBoardId}`}
                                    className={`dashboard-item ${selectedWorkspaceId === workspace.DashBoardId ? 'ui-selected' : 'ui-not-selected'}`}
                                    onClick={() => handleWorkspaceSelection(workspace.DashBoardId)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <div className="float-left fieldradio">
                                        <input
                                            type="radio"
                                            id={`dashboard_radio_${workspace.DashBoardId}`}
                                            name="dashboard_radio"
                                            value={workspace.DashBoardId}
                                            onChange={() => handleWorkspaceSelection(workspace.DashBoardId)}
                                            checked={selectedWorkspaceId === workspace.DashBoardId}
                                            style={{ cursor: 'pointer' }}
                                        />
                                    </div>
                                    <div className="float-left fieldcontent">
                                        <div
                                            className="dashboard-list-header"
                                            dangerouslySetInnerHTML={{ __html: workspace.Name }}
                                        />
                                        <div
                                            className="dashboard-list-sub-header"
                                            dangerouslySetInnerHTML={{ __html: workspace.Description }}
                                        />
                                    </div>
                                    <div className="clear-both"></div>
                                </li>
                            ))
                        ) : (
                            <li className="dashboard-item no-matches" style={{ textAlign: 'left', padding: '10px' }}>
                                Sorry, no matches found. Try a different search.
                            </li>
                        )}
                    </ol>
                    <div
                        id="valmsg_role_dashboards_to_add"
                        className="padding-top-small field-validation-error"
                    ></div>
                    <span className="clear-both"></span>
                    <span
                        id="role_dashboard_to_add_loading"
                        className="hide ajax-loading-box view-dashboard-loading"
                    >
                        <span className="ajax-loading-image"></span>Loading...
                    </span>

                    <div className="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix">
                        <div className="ui-dialog-buttonset">
                            <button
                                type="button"
                                className={`ui-button ui-corner-all ui-widget app-button negative`}
                                onClick={() => {
                                    setSearchTerm('')
                                    onClose()
                                }}
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                className={`ui-button ui-corner-all ui-widget app-button`}
                                disabled={isProcessing}
                                onClick={async () => {
                                    if (selectedWorkspaceId && onSave && !isProcessing) {
                                        setIsProcessing(true)
                                        try {
                                         await onSave(selectedWorkspaceId)
                                        } finally {
                                            setIsProcessing(false)
                                        }
                                    }
                                }}
                            >
                                Add Workspace to Role
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddWorkspaceToRole
